import { Box } from "@mui/material";
import { useResetBrandingImageType } from "../../modules/brand-kit/hooks/use-reset-branding-image-type";
import { BrandingBar } from "../../modules/branding-bar/branding-bar";
import { DiscoverSearchResults } from "../../modules/discover/discover-search-results";
import { useDiscoverLibraryLoader } from "../../modules/discover/hooks/use-libary-loader";
import { Page } from "../../modules/layout/components/page";
import { PageActions } from "../../modules/layout/components/page-actions";
import { PageContent } from "../../modules/layout/components/page-content";
import { PageHeader } from "../../modules/layout/components/page-header";
import { PageHeading } from "../../modules/layout/components/page-heading";
import { LiveSearchField } from "../../modules/search/live-search-field";
import { Breadcrumbs } from "../../modules/tabbed-programs/breadcrumbs";

import type { FC } from "react";

const DiscoverSearchPage: FC = () => {
  useResetBrandingImageType();
  useDiscoverLibraryLoader();

  return (
    <Page title="Discover: Search | ChangeEngine">
      <PageHeader>
        <Breadcrumbs crumbs={[{ to: "/discover", title: "Discover" }, { title: "Search" }]} />
        <PageHeading heading="Discover" />
        <PageActions></PageActions>
      </PageHeader>
      <BrandingBar visualStyleSelector />
      <PageContent>
        <Box sx={{ minWidth: 200, maxWidth: 510, mt: 4 }}>
          <LiveSearchField />
        </Box>
        <DiscoverSearchResults mt={4} />
      </PageContent>
    </Page>
  );
};

export default DiscoverSearchPage;
